import React, { useEffect, useState } from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import Loader from '../sturtural/Loader';

const HeaderInfoValidation = ({solicitud, title}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    let url = `${BASE_API}demand/info/${solicitud}`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }).then(res => { 
            if(res.response == 'on') {
                let demand = res.demand;
                setData(demand);
                setError(false); 
            } else if(res.response == 'off') {
                setError(true);
            }
            setLoading(false); 
        });
    }, [solicitud]);

    return (
        <>
            {!error &&

                <div className="card">
                    <div>
                        <div className="font-11 text-3xl text-900">Información del registro</div>
                        
                        <div className="flex align-items-center text-700 flex-wrap">
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>
                                    {data.nombre} {data.apellido1} {data.apellido2}
                                </span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>CURP: {data.curp}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>FECHA NACIMIENTO: {data.fechanacimiento}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>GENERO: {(data.genero == 'H' ? 'HOMBRE':'MUJER')}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.correo_electronico}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.telefono}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>DOMICILIO: {data.domicilio}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.codigo_postal}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>COLONIA: {data.colonia}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.institucion}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.carrera}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>NIVEL: {data.nivel}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.pais}</span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.entidad}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default HeaderInfoValidation;




{/* <div className="card">
                <div>
                    <div className="font-medium text-3xl text-900">{title}</div>
                    
                    <div className="flex align-items-center text-700 flex-wrap">
                        <div className="mr-5 flex align-items-center mt-3">
                            <i className="pi pi-check-circle mr-2"></i>
                            <span>
                                {data.nombre} {data.apellido1} {data.apellido2}
                            </span>
                        </div>
                        <div className="mr-5 flex align-items-center mt-3">
                            <i className="pi pi-check-circle mr-2"></i>
                            <span>{data.curp}</span>
                        </div>
                        <div className="flex align-items-center mt-3">
                            <i className="pi pi-check-circle mr-2"></i>
                            <span>{data.correo_electronico}</span>
                        </div>
                    </div>
                </div>
            </div> */}


        //     <div className="p-4">
        //     {handleStatus(el.statusid, el.status)}
        //     <div className="text-900 my-3 text-xl font-medium">{el.nombre + ' ' + el.apellido1 + ' ' + el.apellido2}</div>
        // </div>
        // <div className="col-12">
        //     <ul className="list-none p-10 m-0 flex-grow-1">
        //         <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.institucion_educativa}</span></li>
        //         <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.correo_electronico}</span></li>
        //         <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.telefono}</span></li>
        //         <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.fecha_registro}</span></li>
        //     </ul>
        // </div>